import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/core/services/session.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { SafeUrl } from '@angular/platform-browser';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';

const permissions = {
  USER_LIST: 1,
  USER_ADD: 2,
  USER_EDIT: 3,
  USER_DELETE: 4
}

@Component({
  selector: 'vendor-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
})
export class VendorSideNavigationComponent implements OnInit {

  
  profileName: string;
  jobTitle: string;
  showSubmenu: boolean = false;
  storageObject;
  profileImagePath: SafeUrl = "../assets/images/profile-avatar.svg";
  navMenuitems = [
    {
      label: 'Dashboard',
      code: 'C_DASH',
      icon: 'assets/images/menu/menu_dashboard.svg',
      url: '/vendor/baseapp/dashboard',
      drop: false,
      isMenuActive: true,
      isSubMenuActive: false
    },
    // {
    //   label: 'Integration',
    //   code: 'C_INTBRD',
    //   icon: 'assets/images/menu/menu_integration.svg',
    //   url: '',
    //   drop: false,
    //   isMenuActive: false,
    //   isSubMenuActive: false
    // },
    {
      label: 'Management',
      code: 'C_MANAGMNT',
      icon: 'assets/images/menu/menu_management.svg',
      url: '',
      drop: true,
      isMenuActive: false,
      isSubMenuActive: false,
      class: 'sub',
      submenu : [
        { label: 'User', url: '', isActive: false },
        { label: 'Organization', url: '', isActive: false },
        { label: 'Catalog Manager', url: '', isActive: false },
        { label: 'Product Updates', url: '', isActive: false }
      ]
    },
    // {
    //   label: 'Vendor Management',
    //   code: 'C_MANAGMNT',
    //   icon: 'assets/images/menu/menu_management.svg',
    //   url: '',
    //   drop: true,
    //   isMenuActive: true,
    //   isSubMenuActive: false,
    //   class: 'sub',
    //   submenu : [
    //     { label: 'Api Dashboard', url: '', isActive: false },
    //     { label: 'Api Catalog', url: '', isActive: false }
    //   ]
    // }
  ];

  constructor(
    public sessionService: SessionService,
    private menuService: MenuService,
    private backendService: BackendService,
    private vendorBackendService: VendorBackendService,
    public helperService: HelperService) {
    }


  ngOnInit() {
    this.helperService.objectFromStorage$.subscribe((obj) => {
      this.storageObject = obj;
      //console.log("f", obj);
      this.getProfileImage(obj);
    });
    this.menuService.tokenFromStorage$.subscribe((res)=>{
      if(res){
        let token: String = res as any;
        // let decoded_token = JSON.parse(atob(token.split('.')[1]));
        // //console.log(decoded_token);
        // if(decoded_token.role.role_id == 1){
        //   // SUPER ADMIN MENU
        //   for (let i = 0 ; i < this.navMenuitems.length ; i++) {
        //     this.navMenuitems[i].isMenuActive = true;
        //     if(i == 6 || i == 8){
        //       if(this.navMenuitems[i].submenu.length > 0){
        //         for(let j = 0; j< this.navMenuitems[i].submenu.length; j++){
        //           this.navMenuitems[i].submenu[j].isActive = true;
        //         }
        //       }
        //     }
        //   }
        // }
        // if(decoded_token.role.role_id == 2){
        //   // ORGANIZATION USER MENU
        //   for (let i = 0 ; i < this.navMenuitems.length ; i++) {
        //     this.navMenuitems[i].isMenuActive = false;
        //     if(i == 2 || i == 3 || i == 4 || i == 5 || i == 6 || i == 7 || i == 9 || i == 10) continue;
        //     this.navMenuitems[i].isMenuActive = true;
        //     if(i == 6 || i == 8){
        //       if(this.navMenuitems[i].submenu.length > 0){
        //         for(let j = 0; j< this.navMenuitems[i].submenu.length; j++){
        //           this.navMenuitems[i].submenu[j].isActive = false;
        //           if(j == 1 || j == 2 || j == 3) continue;
        //           this.navMenuitems[i].submenu[j].isActive = true;
        //         }
                
        //       }
        //     }
        //   }
        // }
        // if(decoded_token.role.role_id == 4){
        //   // CATALOG ADMIN MENU
        //   for (let i = 0 ; i < this.navMenuitems.length ; i++) {
        //     this.navMenuitems[i].isMenuActive = false;
        //     if(i == 6 || i == 8){
        //       if(this.navMenuitems[i].submenu.length > 0){
        //         for(let j = 0; j< this.navMenuitems[i].submenu.length; j++){
        //           this.navMenuitems[i].submenu[j].isActive = true;
        //         }
        //       }
        //     }
        //   }
        //   this.navMenuitems[0].isMenuActive = true;
        //   this.navMenuitems[6].isMenuActive = true;
        //   this.navMenuitems[7].isMenuActive = true;
        // }
        // if(decoded_token.role.role_id == 5){
        //   // student MENU
        //   for (let i = 0 ; i < this.navMenuitems.length ; i++) {
        //     this.navMenuitems[i].isMenuActive = false;
        //     if(i == 6 || i == 8){
        //       if(this.navMenuitems[i].submenu.length > 0){
        //         for(let j = 0; j< this.navMenuitems[i].submenu.length; j++){
        //           this.navMenuitems[i].submenu[j].isActive = false;
        //         }
        //       }
        //     }
        //   }
        //   this.navMenuitems[0].isMenuActive = true;
        // }       
        // if(decoded_token.role.role_id == 3){
        //   // USER MENU
        //   for (let i = 0 ; i < this.navMenuitems.length ; i++) {
        //     this.navMenuitems[i].isMenuActive = false;
        //     if(i == 6 || i == 8){
        //       if(this.navMenuitems[i].submenu.length > 0){
        //         for(let j = 0; j< this.navMenuitems[i].submenu.length; j++){
        //           this.navMenuitems[i].submenu[j].isActive = false;
        //         }
        //       }
        //     }
        //   }
        //   this.navMenuitems[0].isMenuActive = true;
        //   this.navMenuitems[1].isMenuActive = true;
        //   decoded_token.permissions.forEach(perm =>{
        //     if(perm.perm_mod == 'USER_LIST') {
        //       let obj = this.findTheObject(this.navMenuitems, "C_MANAGMNT");
        //       obj.isMenuActive = true;
        //       obj.submenu[0].isActive = true;
        //     }else if(perm.perm_mod == 'IB_LIST'){
        //       let obj = this.findTheObject(this.navMenuitems, "C_INTBRD");
        //       obj.isMenuActive = true;
        //     }else if(perm.perm_mod == 'API_CAT_LIST'){
        //       let obj = this.findTheObject(this.navMenuitems, "C_API_CAT");
        //       obj.isMenuActive = true;
        //     }
        // })
        // }
      }
    })
  }

  getProfileImage(_storage){
    let payload = {
      "img_collection_id": _storage.profileImageId
    }
    this.vendorBackendService.fileUpload('getProfileImage', 'post', payload, _storage.token).subscribe(
      (data: any) => {
        this.profileImagePath = 'data:image/jpg;base64,' + data.profileImage_hash;
      },
      (error)=>{
        //console.log(error);
      }
    )
  }

  findTheObject(array, key){
    return array.find(function (o) { return o.code == key });
  }

  menuItemHandler(): void {
    this.showSubmenu = !this.showSubmenu;
  }

  toggleDropdown(label) {
    const obj = this.navMenuitems.find(function (o) { return o.label === label });
    obj['isSubMenuActive'] = !obj.isSubMenuActive;
  }

}
